import { MapStore } from "Utils/mobx";
import { CompetitionPhase } from "./CompetitionPhase";

class CompetitionPhaseStore extends MapStore<CompetitionPhase> {}

export default CompetitionPhaseStore;
